import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bookingOfChildActions } from "../redux/slices/bookingOfChildSlice";
import { bookingActions } from "../redux/slices/bookingSlice";
import { RootState } from "../store/store";

export const useBookingState = ({ mode }: { mode?: TProdAttrPickerMode }) => {
  return useSelector((state: RootState) => {
    if (mode === "POPUP") {
      return state.bookingOfChild;
    } else {
      return state.booking;
    }
  });
};

export const useBookingDispatch = ({ mode }: { mode: TProdAttrPickerMode }) => {
  const dispatch = useDispatch();
  const actions = useMemo(
    () => (mode === "POPUP" ? bookingOfChildActions : bookingActions),
    [mode],
  );
  const init = useCallback(
    (productData?: ProductDetailResponse, oldState?: BookingState | null) => {
      if (!productData) {
        // dispatch(actions.replaceBookingAttributes([]));
        dispatch(actions.clear());
        return false;
      }
      console.log("useBookingDispatch init", productData, oldState);
      dispatch(actions.captureProductData({ product: productData, oldState }));
      return true;
    },
    [dispatch, actions],
  );

  const bookingPick = useCallback(
    (pl: BookingAttributeDTO) => {
      dispatch(actions.bookingPick(pl));
    },
    [dispatch, actions],
  );

  const bookingPickLs = useCallback(
    (ls: BookingAttributeDTO[]) => {
      dispatch(actions.bookingPickLs(ls));
    },
    [dispatch, actions],
  );
  const clear = useCallback(() => {
    dispatch(actions.clear());
  }, [dispatch, actions]);

  const deSelectChildProducts = useCallback(
    (payload: { productIds: number[] }) => {
      dispatch(actions.deSelectChildProducts(payload));
    },
    [dispatch, actions],
  );

  const memoizedValue = useMemo(() => {
    return {
      clear,
      init,
      bookingPick,
      bookingPickLs,
      deSelectChildProducts,
    };
  }, [clear, init, bookingPick, bookingPickLs, deSelectChildProducts]);

  return memoizedValue;
};
